import { ApiHttpClient } from "../../common/http/api-http-client";
import { ResourceBaseService } from "../../common/resource-base/resource-base.service";
import { TaskDto } from "./task.dto";
import { CreateTaskDto } from "./create-task.dto";
import { UpdateTaskDto } from "./update-task.dto";
import { HttpRequest } from "@/core/common/http/http-request";
import { plainToInstance } from "class-transformer";
import { CreateFileDto } from "@/core/features/file/create-file.dto";
import { TechnicalReportDto } from "@/core/features/technical-reports/technical-report.dto";
import { UpdateTechnicalReportSectionTextDto } from "@/core/features/tasks/update-technical-report-section-text.dto";
import { TaskFileCategoryEnum } from "@altertec_gparn/lib";

export class TasksResource extends ResourceBaseService<TaskDto, CreateTaskDto, UpdateTaskDto> {
  protected EntityDto = TaskDto;
  protected CreateEntityDto = CreateTaskDto;
  protected UpdateEntityDto = UpdateTaskDto;

  constructor(protected readonly apiHttpClient: ApiHttpClient) {
    super(apiHttpClient, "/tasks");
  }

  createAttachments(
    id: string,
    body: CreateFileDto[],
    technicalReportId?: string,
    reportSectionId?: string,
    category?: TaskFileCategoryEnum
  ): Promise<TaskDto> {
    return this.apiHttpClient.request<{ bulk: CreateFileDto[] }, TaskDto>(
      HttpRequest.create({
        url: this.resourceUrl + "/" + id + "/attachments",
        method: "POST",
        auth: true,
        body: {
          reportSectionId: reportSectionId,
          technicalReportId: technicalReportId,
          category: category,
          bulk: plainToInstance(CreateFileDto, body, { excludeExtraneousValues: true }),
        },
      })
    );
  }

  getTechnicalReport(taskId: string): Promise<TechnicalReportDto | null> {
    return this.apiHttpClient
      .request<null, TechnicalReportDto>(
        HttpRequest.create({
          url: this.resourceUrl + "/" + taskId + "/report",
          method: "GET",
          auth: true,
        })
      )
      .then((result) => (result ? plainToInstance(TechnicalReportDto, result) : null));
  }

  updateReportSectionText(taskId: string, body: UpdateTechnicalReportSectionTextDto): Promise<TaskDto> {
    return this.apiHttpClient.request<UpdateTechnicalReportSectionTextDto, TaskDto>(
      HttpRequest.create({
        url: this.resourceUrl + "/" + taskId + "/report-section-text",
        method: "PATCH",
        auth: true,
        body: plainToInstance(UpdateTechnicalReportSectionTextDto, body, { excludeExtraneousValues: true }),
      })
    );
  }
}
